/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Pagination from 'components/atoms/pagination';
import colors from 'styles/colors';
import { ItemVencido, MyHistoryState } from 'store/modules/my_history_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { list_itens } from 'store/modules/my_history_store/actions';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import { Container } from './styles';

interface ModalLicitacaoMyHistoryProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  item: ItemVencido;
}

const ModalLicitacaoMyHistory = (props: ModalLicitacaoMyHistoryProps) => {
  const { showModal, setShowModal, item } = props;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { my_history, request_followups } = useSelector<ApplicationState, MyHistoryState>(
    (state) => state.session.my_history,
  );
  const indexOfLastPost = currentPage * 5;
  const indexOfFirstPost = indexOfLastPost - 5;
  const currentPosts = my_history?.itens?.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    dispatch(list_itens(item?.bidding_id));
  }, []);

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Licitação</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <p className="font-weight-bold">Objeto</p>
                  <p>{item?.objeto}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Nº ConLicitação</p>
                  <p>{item?.bidding_id}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Data</p>
                  <p>{moment(item?.data_validade).format('DD/MM/YYYY')}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Edital</p>
                  <p>{item?.edital}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Processo</p>
                  <p>{item?.processo}</p>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-6">
                  <p className="font-weight-bold">Órgão</p>
                  <p>{item?.orgao}</p>
                </div>
                <div className="col-md-6">
                  <p className="font-weight-bold">Cidade</p>
                  <p>
                    {item?.cidade} / {item?.estado}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="p-3">
              <p className="font-weight-bold ml-2">
                Total de {my_history?.total_itens} itens com vencedor
              </p>
              {request_followups?.loading ? (
                <Loader />
              ) : (
                <Container>
                  <table className="table table-bordered">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item</th>
                        <th scope="col">Vencedor</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Qnt.</th>
                        <th scope="col">Valor total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPosts?.map((item) => (
                        <tr>
                          <td>{item?.numero_item}</td>
                          <td title={item?.participante_nome}>{item?.participante_nome}</td>
                          <td title={item?.descricao}>{item?.descricao}</td>
                          <td>{item?.quantidade_ofertada}</td>
                          <td>
                            {item?.valor_final?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Container>
              )}
            </div>
            <div className="row d-print-none">
              <div className="col-md-12 px-4 mb-5">
                <Pagination
                  postsPerPage={5}
                  totalPosts={my_history?.total_itens}
                  paginate={paginate}
                  currentPage={currentPage}
                  firstAndLastPage
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLicitacaoMyHistory;
